import DataVerification from "./steps/DataVerification";
import ClientData from "./steps/client-data/ClientData";
import CertificateData from "./steps/certificate-data/CertificateData";
import InitialStep from "./steps/InitialStep";
import UserData from "./steps/user-data/UserData";
import SuccessStep from "./steps/SuccessStep";
import StoreData from "./steps/store-data/StoreData";
import StorePriceListData from "./steps/store-price-list-data/StorePriceListData";

export const FORM_STEP = {
  0: { step: 0, Component: InitialStep },
  1: {
    step: 1,
    subtitle: "Informacije o poslovnom subjektu",
    Component: ClientData,
  },
  2: { step: 2, subtitle: "Informacije o vlasniku", Component: UserData },
  3: {
    step: 3,
    subtitle: "Informacije o prodajnim mjestima i blagajnama",
    Component: StoreData,
  },
  4: {
    step: 4,
    subtitle: "Dodavanje cjenika",
    Component: StorePriceListData,
  },
  5: {
    step: 5,
    subtitle: "Informacije o FINA certifikatu",
    Component: CertificateData,
  },
  6: { step: 6, subtitle: "Provjera podataka", Component: DataVerification },
  7: {
    step: 7,
    subtitle: "Uspjeh",
    Component: SuccessStep,
  },
};

export const FORM_FIELDS = {
  CLIENT_DATA: {
    name: "clientData",
    title: "Podaci o prodajnom mjestu",
    // FIELDS
    OIB: { name: "oib", title: "OIB tvrtke/obrta" },
    NAME: { name: "name", title: "Naziv tvrtke/obrta" },
    IBAN: { name: "iban", title: "IBAN tvrtke/obrta" },
    FISCAL_OBLIGATION: {
      name: "fiscalObligation",
      title: "Fiskalna obveza",
    },
    TAX_OBLIGATION: { name: "taxObligation", title: "Porezna obveza" },
    TAX_NOTE: { name: "taxNote", title: "Porezna bilješka" },
    STREET: { name: "street", title: "Adresa sjedišta" },
    STREET_NUMBER: { name: "streetNumber", title: "Kućni broj" },
    STREET_NUMBER_EXTENSTION: {
      name: "streetNumberExtension",
      title: "Dodatak",
    },
    POSTAL_NUMBER: { name: "postalNumber", title: "Poštanski broj" },
    CITY: { name: "city", title: "Grad" },
  },
  USER_DATA: {
    name: "userData",
    title: "Podaci o vlasniku",
    // FIELDS
    OIB: { name: "oib", title: "OIB" },
    FIRST_NAME: { name: "firstName", title: "Ime" },
    LAST_NAME: { name: "lastName", title: "Prezime" },
    PHONE: { name: "phone", title: "Broj telefona" },
    EMAIL: { name: "email", title: "Email" },
    PIN: { name: "pin", title: "PIN" },
    ADDITIONAL_OIB: { name: "additionalOib", title: "OIB" },
    ADDITIONAL_FIRST_NAME: { name: "additionalFirstName", title: "Ime" },
    ADDITIONAL_LAST_NAME: { name: "additionalLastName", title: "Prezime" },
    ADDITIONAL_PIN: { name: "additionalPin", title: "PIN" },
  },
  STORE_DATA: {
    name: "storeData",
    title: "Prodajna mjesta",
    // FIELDS
    ADDRESS_SAME_AS_CLIENT: { name: "addressSameAsClient", title: "" },
    DESCRIPTION: { name: "description", title: "Opis/Naziv" },
    TAG: { name: "tag", title: "Oznaka prodajnog mjesta" },
    TYPE: { name: "type", title: "Tip prodajnog mjesta" },
    FOOTER_NOTE: { name: "footerNote", title: "Tekst podnožja računa" },
    STREET: { name: "street", title: "Adresa prodajnog mjesta" },
    STREET_NUMBER: { name: "streetNumber", title: "Kućni broj" },
    STREET_NUMBER_EXTENSTION: {
      name: "streetNumberExtension",
      title: "Dodatak",
    },
    POSTAL_NUMBER: { name: "postalNumber", title: "Poštanski broj" },
    CITY: { name: "city", title: "Grad" },
    // POS DATA
    POS_DATA: {
      name: "posData",
      // FIELDS
      TAG: { name: "tag", title: "Oznaka" },
      INVENTORY_NUMBER: { name: "inventoryNumber", title: "ICT broj" },
      DOCUMENT_NUMBER: { name: "documentNumber", title: "Br rač" },
      DEPOSIT: { name: "deposit", title: "Deposit" },
      MSISDN: { name: "msisdn", title: "Serijski br kartice" },
      POS_SERIAL_NUMBER: {
        name: "posSerialNumber",
        title: "Serijski br",
      },
    },
    PRICE_LIST_DATA: {
      name: "priceListData",
      ID: { name: "id", title: "Id" },
      NAME: { name: "name", title: "Naziv" },
      CODE: { name: "code", title: "Kod" },
      BAR_CODE: { name: "barCode", title: "Bar kod" },
      DESCRIPTION: { name: "description", title: "Opis" },
      IS_SERVICE: { name: "isService", title: "Usluga" },
      UNIT_OF_MEASURE: { name: "unitOfMeasure", title: "Jedinica mjere" },
      TAX_RATE: { name: "taxRate", title: "Porezna stopa" },
      ITEM_GROUP: {
        name: "itemGroup",
        title: "Grupa artikala",
      },
      PRICE: { name: "price", title: "Cijena" },
      PN: { name: "pn", title: "Povratna naknada" },
      PP: { name: "pp", title: "Pp" },
      FILE: { name: "file", title: "Datoteka" },
    },
  },
  CERTIFICATE_DATA: {
    name: "certificateData",
    title: "Certifikat",
    CERT_PASSWORD: { name: "certPassword", title: "Lozinka" },
    FILE_CONTENT: { name: "fileContent", title: "Certifikat" },
    VALID_FROM: { name: "validFrom", title: "Certifikat vrijedi od" },
    VALID_TO: { name: "validTo", title: "Certifikat vrijedi do" },
  },
};

export const FORM_INITIAL_DATA = {
  // CLIENT DATA
  [FORM_FIELDS.CLIENT_DATA.name]: {
    [FORM_FIELDS.CLIENT_DATA.OIB.name]: "",
    [FORM_FIELDS.CLIENT_DATA.NAME.name]: "",
    [FORM_FIELDS.CLIENT_DATA.IBAN.name]: "",
    [FORM_FIELDS.CLIENT_DATA.FISCAL_OBLIGATION.name]: true,
    [FORM_FIELDS.CLIENT_DATA.TAX_OBLIGATION.name]: true,
    [FORM_FIELDS.CLIENT_DATA.TAX_NOTE.name]: "",
    [FORM_FIELDS.CLIENT_DATA.STREET.name]: "",
    [FORM_FIELDS.CLIENT_DATA.STREET_NUMBER.name]: "",
    [FORM_FIELDS.CLIENT_DATA.STREET_NUMBER_EXTENSTION.name]: "",
    [FORM_FIELDS.CLIENT_DATA.POSTAL_NUMBER.name]: "",
    [FORM_FIELDS.CLIENT_DATA.CITY.name]: "",
  },
  // USER DATA
  [FORM_FIELDS.USER_DATA.name]: {
    [FORM_FIELDS.USER_DATA.OIB.name]: "",
    [FORM_FIELDS.USER_DATA.FIRST_NAME.name]: "",
    [FORM_FIELDS.USER_DATA.LAST_NAME.name]: "",
    [FORM_FIELDS.USER_DATA.PHONE.name]: "",
    [FORM_FIELDS.USER_DATA.EMAIL.name]: "",
    [FORM_FIELDS.USER_DATA.PIN.name]: "",
    [FORM_FIELDS.USER_DATA.ADDITIONAL_OIB.name]: "",
    [FORM_FIELDS.USER_DATA.ADDITIONAL_FIRST_NAME.name]: "",
    [FORM_FIELDS.USER_DATA.ADDITIONAL_LAST_NAME.name]: "",
    [FORM_FIELDS.USER_DATA.ADDITIONAL_PIN.name]: "",
  },
  // STORE DATA {
  [FORM_FIELDS.STORE_DATA.name]: [],
};

const { STORE_DATA } = FORM_FIELDS;
const { PRICE_LIST_DATA } = STORE_DATA;

export const PRICE_LIST_TABLE_COLUMNS = [
  {
    dataField: PRICE_LIST_DATA.NAME.name,
    text: PRICE_LIST_DATA.NAME.title,
  },
  {
    dataField: PRICE_LIST_DATA.CODE.name,
    text: PRICE_LIST_DATA.CODE.title,
  },
  {
    dataField: PRICE_LIST_DATA.BAR_CODE.name,
    text: PRICE_LIST_DATA.BAR_CODE.title,
  },
  {
    dataField: PRICE_LIST_DATA.DESCRIPTION.name,
    text: PRICE_LIST_DATA.DESCRIPTION.title,
  },
  {
    dataField: PRICE_LIST_DATA.IS_SERVICE.name,
    text: PRICE_LIST_DATA.IS_SERVICE.title,
  },
  {
    dataField: PRICE_LIST_DATA.UNIT_OF_MEASURE.name,
    text: PRICE_LIST_DATA.UNIT_OF_MEASURE.title,
  },
  {
    dataField: PRICE_LIST_DATA.TAX_RATE.name,
    text: PRICE_LIST_DATA.TAX_RATE.title,
  },
  {
    dataField: PRICE_LIST_DATA.ITEM_GROUP.name,
    text: PRICE_LIST_DATA.ITEM_GROUP.title,
  },
  {
    dataField: PRICE_LIST_DATA.PN.name,
    text: PRICE_LIST_DATA.PN.title,
  },
  {
    dataField: PRICE_LIST_DATA.PRICE.name,
    text: PRICE_LIST_DATA.PRICE.title,
  },
  {
    dataField: PRICE_LIST_DATA.PP.name,
    text: PRICE_LIST_DATA.PP.title,
  },
];
